import { Button, Space, Popover } from "antd";
import { CloseOutlined, FilterOutlined } from "@ant-design/icons";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const Filter = ({
  showClearBtn = false,
  onClear = () => {},
  title,
  content,
  onOpenChange,
  icon = <FilterOutlined />,
  onClick = () => {},
  id = "btn-filter",
  showFilter = true,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.filter");

  return (
    <Space>
      {showFilter && (
        <Popover
          placement="bottomLeft"
          content={content}
          trigger="click"
          onOpenChange={onOpenChange}
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          <Button
            title={btnTitle}
            icon={icon}
            onClick={onClick}
            id={id}
            {...props}
          >
            {btnTitle}
          </Button>
        </Popover>
      )}

      {showClearBtn && (
        <Button onClick={onClear} icon={<CloseOutlined />} danger>
          {t("button.clear_filter")}
        </Button>
      )}
    </Space>
  );
};

export default memo(Filter);
